import React from 'react'

interface BetaLabelProps {
  className?: string
  variant?: 'gradient' | 'solid'
  size?: 'xs' | 'sm' | 'md'
}

export const BetaLabel: React.FC<BetaLabelProps> = ({
  className = '',
  size = 'md',
}) => {
  const sizeClasses = {
    xs: 'w-12 h-5',
    sm: 'w-20 h-8',
    md: 'w-24 h-10',
  }

  return (
    <div
      className={`
          inline-flex items-center justify-center
          ${sizeClasses[size]}
          ${className}
        `}
      role="img"
      aria-label="Beta feature"
    >
      <BetaSVG />
    </div>
  )
}

const BetaSVG = () => {
  return (
    <svg
      viewBox="0 0 100 30"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <linearGradient id="betaGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#ff3366', stopOpacity: 1 }} />
          <stop offset="20%" style={{ stopColor: '#ff5e94', stopOpacity: 1 }} />
          <stop offset="40%" style={{ stopColor: '#a855f7', stopOpacity: 1 }} />
          <stop offset="60%" style={{ stopColor: '#3b82f6', stopOpacity: 1 }} />
          <stop offset="80%" style={{ stopColor: '#06b6d4', stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: '#10b981', stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>

      <text
        x="50"
        y="20"
        fontFamily="Archivo, Arial, sans-serif"
        fontSize="12"
        fontWeight="700"
        letterSpacing="0.05em"
        textAnchor="middle"
        fill="url(#betaGradient)"
        filter="url(#betaGlow)"
        dominantBaseline="middle"
      >
        BETA
      </text>
    </svg>
  )
}
